
import { JOKI } from '../../JOKI';

export function warning(messageText) {
    JOKI.trigger({
        to: "NotificationService",
        key: "newNotification",
        body: {
            level: "WARNING",
            text: messageText,
        },
    });
}

export function critical(messageText) {
    JOKI.trigger({
        to: "NotificationService",
        key: "newNotification",
        body: {
            level: "CRITICAL",
            text: messageText,
        },
    });
}

export function notice(messageText) {
    JOKI.trigger({
        to: "NotificationService",
        key: "newNotification",
        body: {
            level: "INFO",
            text: messageText,
        },
    });
}

export function debug({...args}) {
    console.log("Notification:Debug:", args);
    // JOKI.trigger({
    //     to: "NotificationService",
    //     key: "newNotification",
    //     body: {
    //         level: "DEBUG",
    //         text: messageText,
    //     },
    // });

}